import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowBackIcon } from "@twilio-paste/icons/esm/ArrowBackIcon";
var AddParticipantFooter = function (props) {
    var _a;
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "modal-footer", children: [_jsx("div", { className: "d-flex justify-content-start", children: _jsxs("button", { className: "btn btn-secondary", onClick: function () {
                            props.onBack();
                        }, children: [_jsx(ArrowBackIcon, { decorative: true, title: "Back to manage participants", size: "sizeIcon10" }), "Back"] }) }), _jsx("div", { className: "d-flex justify-content-end", children: _jsx("button", { disabled: (_a = props.isSaveDisabled) !== null && _a !== void 0 ? _a : false, className: "btn btn-primary", onClick: function () {
                            props.action();
                        }, children: props.actionName }) })] }) }));
};
export default AddParticipantFooter;
